/* Order Register marks for Partner Hub parcels sent with less payment than the order value, or below cost. */
const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

const when = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "");

/* Partner's last tracking check + pasted last position (from the Partner Hub), under the tracking number. */
export const HubTrackNote = ({ r }) => {
  if (!r.hub_track_position && !r.hub_track_checked_at) return null;
  return (
    <div className="mt-0.5 max-w-[220px] whitespace-normal text-[9px] leading-tight" data-testid={`or-hub-track-${r.id}`}>
      {r.hub_track_position && <div className="rounded bg-sky-50 px-1 py-0.5 text-sky-900" title={`Pasted by ${r.hub_track_position_by || "partner"} · ${when(r.hub_track_position_at)}`}>
        <b>Hub position:</b> {r.hub_track_position} <span className="text-sky-600">· {when(r.hub_track_position_at)}</span></div>}
      {r.hub_track_checked_at && <div className="text-slate-500">Partner checked {when(r.hub_track_checked_at)}</div>}
    </div>
  );
};

export const HubMoneyTag = ({ r }) => {
  if (!(r.hub_short_payment > 0) && !(r.hub_loss > 0)) return null;
  return (
    <div className="mt-0.5 flex flex-col gap-0.5">
      {r.hub_short_payment > 0 && <span className="inline-block whitespace-nowrap rounded bg-amber-100 px-1.5 py-0.5 text-[9px] font-bold text-amber-800"
        title="Partner sent this parcel with less payment credited than the order value" data-testid={`or-short-pay-${r.id}`}>Less payment received · {inr(r.hub_short_payment)}</span>}
      {r.hub_loss > 0 && <span className="inline-block whitespace-nowrap rounded bg-rose-100 px-1.5 py-0.5 text-[9px] font-bold text-rose-700"
        title="One or more products sold below cost price" data-testid={`or-below-cost-${r.id}`}>Below cost · loss {inr(r.hub_loss)}</span>}
    </div>
  );
};
